module.exports = __webpack_public_path__ + "images/fa-course-exams-lms.jpg";